const ELocalizingMaterials = {
  IN_WAREHOUSE: 'entity.specialrequest.materialLocalisations.warehouse',
  ON_SITE: 'entity.specialrequest.materialLocalisations.onsite',
  OTHER_AND_SPECIFY: 'entity.specialrequest.materialLocalisations.other',
  DEFAULT: ''
}

export default ELocalizingMaterials;
